import { Flex, Switch, Text } from '@chakra-ui/react';

import { ToggleRowProps } from './ToggleRow.types';

function ToggleRow({ label, description, isChecked, onChange, testId }: ToggleRowProps) {
  return (
    <Flex w="full" align="center" justify="space-between" gap="15px">
      <Flex flexDir="column">
        <Text textStyle="smallMedium" color="brand.black">
          {label}
        </Text>
        <Text textStyle="extraSmallRegular" color="brand.darkGray">
          {description}
        </Text>
      </Flex>
      <Switch
        colorScheme="badge.invited"
        size="lg"
        isChecked={isChecked}
        onChange={(event) => onChange(event.target.checked)}
        data-testid={testId}
      />
    </Flex>
  );
}

export { ToggleRow };
